module.exports = __webpack_public_path__ + "img/ltc_tumb.626105ff.jpg";